import React from 'react';
import { useDynamicWidgets, UseDynamicWidgetsProps, useInstantSearch } from 'react-instantsearch';
import { colorSwatchKey } from '../../hooks/useColorSwatches';
import { VirtualRefinementList } from './VirtualRefinementList';
import { VirtualToggleRefinement } from './VirtualToggleRefinement';
import { VirtualRange } from './VirtualRange';
import { Facets, STOCK_FACETS } from '~/services/instantsearch';

// Already rendered below, so they must not be mounted a second time.
const STATIC_ATTRIBUTES: string[] = [Facets.OFFERS, Facets.MEMBERS_OFFER, ...STOCK_FACETS];

export const VirtualFacets: React.FC<UseDynamicWidgetsProps> = (props) => {
    const { indexUiState } = useInstantSearch();

    const { attributesToRender } = useDynamicWidgets({
        maxValuesPerFacet: 1000,
        facets: ['*'],
        ...props,
    });

    // Sort replicas order facets differently (and the URL's sort picks one on load), so refined attributes are always kept mounted or their refinements are dropped.
    const refinedAttributes = [
        ...Object.keys(indexUiState.refinementList ?? {}),
        ...Object.keys(indexUiState.toggle ?? {}),
    ].filter((attribute) => !STATIC_ATTRIBUTES.includes(attribute));

    const allAttributes = [...new Set([...attributesToRender, ...refinedAttributes])];

    return (
        <>
            <VirtualToggleRefinement attribute={Facets.OFFERS} />
            <VirtualToggleRefinement attribute={Facets.MEMBERS_OFFER} />

            <VirtualRefinementList attribute={Facets.STORE} />
            <VirtualToggleRefinement attribute={Facets.STORE_WEB} />
            <VirtualToggleRefinement attribute={Facets.STORE_ANY} />

            <VirtualRange attribute={Facets.EFFECTIVE_PRICE} />

            {allAttributes.map((attribute) => {
                switch (attribute) {
                    case colorSwatchKey:
                        return null;

                    case Facets.SOLE_REPRESENTATION:
                    case Facets.IS_NEW:
                    case Facets.ALLERGY_FRIENDLY:
                    case Facets.PERSONALIZATION:
                        return <VirtualToggleRefinement key={attribute} attribute={attribute} />;

                    default:
                        return <VirtualRefinementList key={attribute} attribute={attribute} />;
                }
            })}
        </>
    );
};
